<template>
  <div class="signature">
    <!-- <div class="img" v-if="isShowImg">
      <img :src="signatureSrc" alt />
    </div>-->
    <div class="canvas" @mouseenter="mouseenter">
      <canvas
        width="476"
        height="200"
        ref="canvas"
        @mousedown="mousedown($event)"
        @mousemove="mousemove($event)"
        @mouseup="mouseup"
        @mouseout="mouseout"
        v-if="isShowCanvas"
      ></canvas>
      <div class="bg" v-else>请在当前页面设置签名</div>
    </div>
    <div class="btns" v-if="!isShowImg">
      <el-button @click="revokeSignature">撤销</el-button>
      <el-button @click="resetSignature">重置</el-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Signature",
  props: {
    isShowImg: {
      type: Boolean,
      default: false,
    },
    isShowCanvas: {
      type: Boolean,
      default: false,
    },
    signatureSrc: {
      type: String,
    },
  },
  data() {
    return {};
  },
  //   created() {},
  methods: {
    mouseenter() {
      this.$emit("mouseenter");
    },
    mousedown(e) {
      this.$emit("mousedown", e);
    },
    mousemove(e) {
      this.$emit("mousemove", e);
    },
    mouseup() {
      this.$emit("mouseup");
    },
    mouseout() {
      this.$emit("mouseout");
    },
    // 撤销
    revokeSignature() {
      this.$emit("revoke");
    },
    // 重置
    resetSignature() {
      this.$emit("reset");
    },
  },
};
</script>

<style lang='less' scoped>
.signature {
  .canvas {
    width: 476px;
    height: 200px;
    line-height: 200px;
    text-align: center;
    border: 1px solid rgba(226, 229, 236, 0.62);
    .bg {
      width: 476px;
      height: 200px;
      line-height: 200px;
      background: #f8fafb;
      text-align: center;
      font-size: 15px;
      color: #838997;
      user-select: none;
    }
  }
  .btns {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
  }
}
</style>
